import { render, staticRenderFns } from "./JEditor.vue?vue&type=template&id=9c7b154c&scoped=true&"
import script from "./JEditor.vue?vue&type=script&lang=js&"
export * from "./JEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7b154c",
  null
  
)

export default component.exports